import * as React from 'react';
import type {
  InnerNavigatorOption,
} from 'components/ui/InnerNavigator';
import { usePermissions } from 'hooks';
import { TRANSPORT_ROUTES } from 'routes/transport-routes';


export const useTabOptions = () => {
  const { checkUserAnyPermission } = usePermissions();
  return React.useMemo((): InnerNavigatorOption[] => {
    return [
      {
        route: TRANSPORT_ROUTES.listRoutes().path,
        hasPermission: checkUserAnyPermission(TRANSPORT_ROUTES.listRoutes().permissions),
        title: 'Rotas',
      },
      {
        route: TRANSPORT_ROUTES.createRoute().path,
        hasPermission: checkUserAnyPermission(TRANSPORT_ROUTES.createRoute().permissions),
        title: 'Nova rota',
      },
    ];
  }, [checkUserAnyPermission]);
};